module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "portfolio"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('h2', {
    staticClass: "wow bounce"
  }, [_vm._v("\n          Printer Counters Certification\n          in cooperation with\n          our Partners:\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "iso-section wow fadeIn",
    attrs: {
      "data-wow-delay": "0.6s"
    }
  }, [_c('div', {
    staticClass: "iso-box-section"
  }, [_c('div', {
    staticClass: "iso-box-wrapper col4-iso-box"
  }, _vm._l((_vm.projects), function(project) {
    return _c('div', {
      staticClass: "iso-box graphic photoshop wallpaper col-md-3 col-sm-6 col-xs-12",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('div', {
      staticClass: "portfolio-thumb",
      staticStyle: {
        "height": "100px",
        "align-content": "center",
        "vertical-align": "central"
      },
      attrs: {
        "title": project.title
      }
    }, [_c('img', {
      staticClass: "fluid-img",
      attrs: {
        "src": project.img,
        "alt": "portfolio img"
      }
    })])])
  }), 0)])])])]), _vm._v(" "), _c('tryBtn')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a25362a2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/projects.vue
// module id = 743
// module chunks = 0